// routers configuration file
import type { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'root',
    component: () => import('@/views/Layout.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home/HomeView.vue'),
        meta: {
          label: '首页',
          name: 'home',
          componentName: 'HomeView',
          disableClose: true,
        },
      },
      {
        path: '/home',
        redirect: { name: 'home' },
      },
      {
        path: '/management/user/list',
        name: 'management/user/list',
        component: () => import('@/views/System//AccountManageListView.vue'),
        meta: {
          label: '账号管理',
          name: 'management/user',
          componentName: 'AccountManageListView',
        },
      },
      {
        path: '/management/role/list',
        name: 'management/role/list',
        component: () => import('@/views/System/RolesManageListView.vue'),
        meta: {
          label: '角色管理',
          name: 'management/role',
          componentName: 'RolesManageListView',
        },
      },
      {
        path: '/management/company/list',
        name: 'management/company/list',
        component: () => import('@/views/System/Company/CompanyManageView.vue'),
        meta: {
          label: '公司主体管理',
          name: 'management/company',
          componentName: 'CompanyManageView',
        },
      },
      {
        path: '/management/payee/partner/list',
        name: 'management/payee/partner/list',
        component: () => import('@/views/System/Payee/PayeeManageListView.vue'),
        meta: {
          label: '往来单位管理',
          name: 'management/payee',
          componentName: 'PayeeManageListView',
        },
      },
      {
        path: '/management/payee/bank/list',
        name: 'management/payee/bank/list',
        component: () => import('@/views/System/Payee/PayeeBankListView.vue'),
        meta: {
          label: '往来单位银行账户管理',
          name: 'management/payee',
          componentName: ['PayeeManageListView', 'PayeeBankListView'],
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/management/payer/list',
        name: 'management/payer/list',
        component: () => import('@/views/System/Payer/PayerManageListView.vue'),
        meta: {
          label: '公司账户管理',
          name: 'management/payer',
          componentName: 'PayerManageListView',
        },
      },
      {
        path: '/management/payer/bank/list',
        name: 'management/payer/bank/list',
        component: () => import('@/views/System/Payer/PayerBankListView.vue'),
        meta: {
          label: '银行账户管理',
          name: 'management/company/bank/list',
          componentName: ['PayerBankListView'],
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/management/ad_channel/list',
        name: 'management/ad_channel/list',
        component: () => import('@/views/System/AdChannel/AdChannelManageListView.vue'),
        meta: {
          label: '广告渠道管理',
          name: 'management/ad_channel',
          componentName: 'AdChannelManageListView',
        },
      },
      {
        path: '/management/subject/tree',
        name: 'management/subject/tree',
        component: () => import('@/views/System/Subject/SubjectTableView.vue'),
        meta: {
          label: '科目管理',
          name: 'management/subject',
          componentName: 'SubjectTableView',
        },
      },
      {
        path: '/management/employee/list',
        name: 'management/employee/list',
        component: () => import('@/views/System/EmployeeInfo/EmployeeInfoListView.vue'),
        meta: {
          label: '员工信息管理',
          name: 'management/employee',
          componentName: 'EmployeeInfoListView',
        },
      },
      {
        path: '/management/dict/tree',
        name: 'management/dict/tree',
        component: () => import('@/views/System/Dictionary/DictionaryListView.vue'),
        meta: {
          label: '字典管理',
          name: 'management/dict',
          componentName: 'DictionaryListView',
        },
      },
      {
        path: '/management/project/tree',
        name: 'management/project/tree',
        component: () => import('@/views/System/Project/ProjectListView.vue'),
        meta: {
          label: '财务项目管理',
          name: 'management/project',
          componentName: 'ProjectListView',
        },
      },
      {
        path: '/teller/management/list',
        name: 'teller/management/list',
        component: () => import('@/views/FinanceTool/TellerManageListView.vue'),
        meta: {
          label: '出纳管理',
          name: 'teller/management',
          componentName: 'TellerManageListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/teller/bill_book/list',
        name: 'teller/bill_book/list',
        component: () => import('@/views/FinanceTool/BillBook/BillBookListView.vue'),
        meta: {
          label: '台账管理',
          name: 'teller/bill_book',
          componentName: 'BillBookListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/teller/subject/list',
        name: 'teller/subject/list',
        component: () => import('@/views/FinanceTool/Subject/FinanceSubjectListView.vue'),
        meta: {
          label: '科目编制',
          name: 'teller/subject',
          componentName: 'FinanceSubjectListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/teller/journal_entry/list',
        name: 'teller/journal_entry/list',
        component: () => import('@/views/FinanceTool/FinancialAccounting/FinancialAccountingListView.vue'),
        meta: {
          label: '财务做账',
          name: 'teller/journal_entry',
          componentName: ['FinancialAccountingListView', 'FinancialAccountingDetailView'],
        },
      },
      {
        path: '/teller/journal_entry/record',
        name: 'teller/journal_entry/record',
        component: () => import('@/views/FinanceTool/FinancialAccounting/FinancialAccountingRecordListView.vue'),
        meta: {
          label: '财务做账',
          name: 'teller/journal_entry/record',
          componentName: ['FinancialAccountingRecordListView', 'FinancialAccountingDetailView'],
        },
      },
      {
        path: '/teller/journal_entry/tmpl/list',
        name: 'teller/journal_entry/tmpl/list',
        component: () => import('@/views/FinanceTool/FinancialAccounting/FinancialVoucherListView.vue'),
        meta: {
          label: '财务做账',
          name: 'teller/journal_entry/tmpl',
          componentName: ['FinancialVoucherListView', 'FinancialAccountingDetailView'],
        },
      },
      {
        path: '/teller/journal_entry/paypal/list',
        name: 'teller/journal_entry/paypal/list',
        component: () => import('@/views/FinanceTool/FinancialAccounting/FinancialPaypalListView.vue'),
        meta: {
          label: '财务做账',
          name: 'teller/journal_entry/paypal',
          componentName: ['FinancialPaypalListView'],
        },
      },
      {
        path: '/payout/ad_cost/list',
        name: 'payout/ad_cost/list',
        component: () => import('@/views/Payout/PayoutAdvertiseListView.vue'),
        meta: {
          label: '广告费用管理',
          name: 'payout/ad_cost',
          componentName: 'PayoutAdvertiseListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/payout/reimbursement/list',
        name: 'payout/reimbursement/list',
        component: () => import('@/views/Payout/PayoutReimbursementListView.vue'),
        meta: {
          label: '报销费用管理',
          name: 'payout/reimbursement',
          componentName: 'PayoutReimbursementListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/payout/payment/list',
        name: 'payout/payment/list',
        component: () => import('@/views/Payout/PayoutExpenseListView.vue'),
        meta: {
          label: '费用付款管理',
          name: 'payout/payment',
          componentName: 'PayoutExpenseListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/payout/payment_recharge/list',
        name: 'payout/payment_recharge/list',
        component: () => import('@/views/Payout/PayoutRechargeListView.vue'),
        meta: {
          label: '内部转账/充值管理',
          name: 'payout/payment_recharge',
          componentName: 'PayoutRechargeListView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/payout/imprest_record/list',
        name: 'payout/imprest_record/list',
        component: () => import('@/views/Approval/ImprestManageView.vue'),
        meta: {
          label: '备用金管理',
          name: 'payout/imprest_record',
          componentName: 'ImprestManageView',
        },
        props: (route: any) => {
          return {
            ...route.query,
          };
        },
      },
      {
        path: '/payin/income/list',
        name: 'payin/income/list',
        component: () => import('@/views/Payin/PayinIncomeListView.vue'),
        meta: {
          label: '变现收入管理',
          name: 'payin/income',
          componentName: 'PayinIncomeListView',
        },
      },
      {
        path: '/airwallex/record/list',
        name: 'airwallex/record/list',
        component: () => import('@/views/Airwallex/RecordListView.vue'),
        meta: {
          label: '明细列表',
          name: 'airwallex/record',
          componentName: 'RecordListView',
        },
      },
      {
        path: '/airwallex/account/list',
        name: 'airwallex/account/list',
        component: () => import('@/views/Airwallex/AccountListView.vue'),
        meta: {
          label: '店铺列表',
          name: 'airwallex/account',
          componentName: 'AccountListView',
        },
      },
      {
        path: '/airwallex/transaction/list',
        name: 'airwallex/transaction/list',
        component: () => import('@/views/Airwallex/TransactionListView.vue'),
        meta: {
          label: '账单流水',
          name: 'airwallex/transaction',
          componentName: 'TransactionListView',
        },
      },
      {
        path: '/bill_check/invoice/list',
        name: 'bill_check/invoice/list',
        component: () => import('@/views/BillCheck/BillCheckInvoiceManageView.vue'),
        meta: {
          label: '渠道对账Invoice',
          name: 'bill_check/invoice',
          componentName: 'BillCheckInvoiceManageView',
        },
      },
      {
        path: '/bill_check/report/payment/list',
        name: 'bill_check/report/payment/list',
        component: () => import('@/views/BillCheck/BillCheckReportPaymentList.vue'),
        meta: {
          label: '渠道收款报表',
          name: 'bill_check/report/payment',
          componentName: 'BillCheckReportPaymentList',
        },
      },
      {
        path: '/bill_check/record/list',
        name: 'bill_check/record/list',
        component: () => import('@/views/BillCheck/BillCheckRecordManageView.vue'),
        meta: {
          label: '支付渠道对账',
          name: 'bill_check/record',
          componentName: 'BillCheckRecordManageView',
        },
      },
      {
        path: '/bill_check/record/diff-list',
        name: 'bill_check/record/diff-list',
        component: () => import('@/views/BillCheck/BillCheckRecordDiffListView.vue'),
        meta: {
          label: '交易差异明细',
          name: 'bill_check/record/diff-list',
          componentName: 'BillCheckRecordDiffListView',
        },
      },
      {
        path: '/bill_check/record/fee-diff-list',
        name: 'bill_check/record/fee-diff-list',
        component: () => import('@/views/BillCheck/BillCheckRecordFeeDiffListView.vue'),
        meta: {
          label: '费用差异明细',
          name: 'bill_check/record/fee-diff-list',
          componentName: 'BillCheckRecordFeeDiffListView',
        },
      },
      {
        path: '/bill_check/channel/list',
        name: 'bill_check/channel/list',
        component: () => import('@/views/System/TradeChannel/TradeChannelListView.vue'),
        meta: {
          label: '交易渠道管理',
          name: 'bill_check/channel',
          componentName: 'TradeChannelListView',
        },
      },
      {
        path: '/bill_check/data/list',
        name: 'bill_check/data/list',
        component: () => import('@/views/BillCheck/DataSourceManageListView.vue'),
        meta: {
          label: '数据源管理',
          name: 'bill_check/data',
          componentName: 'DataSourceManageListView',
        },
      },
      {
        path: '/bill_check/ad/income/list',
        name: 'bill_check/ad/income/list',
        component: () => import('@/views/Ad/Income/AdIncomeManageView.vue'),
        meta: {
          label: '广告收入管理',
          name: 'bill_check/ad/income',
          componentName: 'AdIncomeManageView',
        },
      },
      {
        path: '/bill_check/ad/payout/list',
        name: 'bill_check/ad/payout/list',
        component: () => import('@/views/Ad/Payout/AdPayoutManageView.vue'),
        meta: {
          label: '广告支出管理',
          name: 'bill_check/ad/payout',
          componentName: 'AdPayoutManageView',
        },
      },
      {
        path: '/bill_check/ad/rebate/list',
        name: 'bill_check/ad/rebate/list',
        component: () => import('@/views/Ad/Rebate/AdRebateManageView.vue'),
        meta: {
          label: '广告返点管理',
          name: 'bill_check/ad/rebate',
          componentName: 'AdRebateManageView',
        },
      },
      {
        path: '/fund/ad/list',
        name: 'fund/ad/list',
        component: () => import('@/views/Ad/IncomeAndPayout/AdInOutListView.vue'),
        meta: {
          label: '广告收支管理',
          name: 'fund/ad',
          componentName: 'AdInOutListView',
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
  },
  {
    path: '/teller/management/signature',
    name: 'teller/management/signature',
    component: () => import('@/views/FinanceTool/SignatureView.vue'),
    meta: {
      label: '签字单',
      name: 'teller/management/signature',
    },
    props: (route: any) => {
      return {
        ...route.query,
      };
    },
  },
  {
    path: '/print/table/preview',
    name: 'print/table/preview',
    component: () => import('@/views/Print/PrintTablePreviewView.vue'),
    meta: {
      title: '打印预览',
      name: 'print/table/preview',
    },
  },
  {
    path: '/:pathMatch(.*)',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
];

export { routes };
